var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui_icon",style:({
    '--icon-size': `${_vm.size}px`,
    '--icon-url': `url(${_vm.sourceUrl})`,
    '--icon-color': _vm.color,
  }),attrs:{"aria-label":_vm.altText || `Icono ${_vm.name}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }